"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cognitiveIconBaseUrl = void 0;
exports.default = CognitiveIcon;
var _react = _interopRequireDefault(require("react"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _useTheme = _interopRequireDefault(require("@mui/material/styles/useTheme.js"));
var _tinycolor = _interopRequireDefault(require("tinycolor2"));
var _clsx = _interopRequireDefault(require("clsx"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** Render an icon defaulted to 20px from icon cdns (returns null if no file is provided) */
function CognitiveIcon(props) {
  if (!props.icon?.file) return null;
  switch (props.icon.type) {
    case 'google':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(GoogleIcon, {
        ...props
      });
    default:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(TadaIcon, {
        ...props
      });
  }
}
const useTadaStyles = (0, _makeStyles.default)({
  small: {
    width: '20px'
  },
  medium: {
    width: '24px'
  },
  large: {
    width: '28px'
  },
  xl: {
    width: '32px'
  }
});
const cognitiveIconBaseUrl = exports.cognitiveIconBaseUrl = 'https://cdn.tadanow.com/icons/Default/';
const defaultInvert = '0.305'; // black invert filter value to match default text color #4E4E4E

function TadaIcon({
  className,
  white,
  fontSize,
  icon,
  bgColor
}) {
  const classes = useTadaStyles();
  const background = bgColor ?? (0, _useTheme.default)().palette.background.main;
  const sizeClass = fontSize === 'small' ? classes.small : fontSize === 'large' ? classes.large : fontSize === 'xl' ? classes.xl : classes.medium;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
    className: (0, _clsx.default)(sizeClass, className),
    style: {
      filter: `invert(${white ? '1' : (0, _tinycolor.default)(background).isDark() ? '1' : defaultInvert})`
    },
    src: `${cognitiveIconBaseUrl}${icon.file}`
  });
}
const useGoogleStyles = (0, _makeStyles.default)(({
  palette
}) => ({
  small: {
    fontSize: '20px'
  },
  medium: {
    fontSize: '24px'
  },
  large: {
    fontSize: '28px'
  },
  mainColor: {
    fill: palette.text.primary
  },
  white: {
    fill: '#fff'
  }
}));
function GoogleIcon({
  className,
  white,
  fontSize,
  icon,
  bgColor
}) {
  const classes = useGoogleStyles();
  const background = bgColor ?? (0, _useTheme.default)().palette.background.main;
  const sizeClass = fontSize === 'small' ? classes.small : fontSize === 'large' ? classes.large : classes.medium;
  const colorClass = white ? classes.white : (0, _tinycolor.default)(background).isDark() ? classes.white : classes.mainColor;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    className: (0, _clsx.default)('material-icons', sizeClass, colorClass, className),
    children: icon.file
  });
}